import React from 'react';
import { BarChart } from '../../../../ui-components/data-viz-ui/charts/bar-chart/BarChart';
import { OverTimeSegmentedBarChartUiComponentProps } from './types';

export const OverTimeSegmentedBarChartUiComponent = (
  props: OverTimeSegmentedBarChartUiComponentProps
) => {
  return (
    <BarChart
      {...props}
      displayConfig={{ ...props.displayConfig, enableSortOrder: false }}
    />
  );
};
